import { put, call, takeLatest } from "redux-saga/effects";

import * as Actions from "redux/actions/Role";
import * as Types from "redux/constants/Role";

import RoleService from "services/RoleService";

export function* fetchRolesEffect() {
    try {
        const { data: roles, success, message } = yield call(RoleService.fetchRoles);
        if (success) {
            yield (put(Actions.fetchRolesOk(roles.result)));
            return;
        }
        yield (put(Actions.fetchRolesFailed(message)));
    } catch ({ response }) {
        yield (
            put(
                Actions.fetchRolesFailed({
                    status: response.status,
                    message: response.data.message,
                    errors: []
                })
            )
        );
    }
}

export function* addRoleEffect({ payload }) {
    try {
        yield call(RoleService.postRole, payload);
        yield (put(Actions.addRoleOk()));
    } catch ({ response }) {
        yield (
            put(
                Actions.addRoleFailed({
                    status: response.status,
                    message: response.data.message,
                    errors: response.data.data.errors ? response.data.data.errors : null,
                })
            )
        );
    }
}

export function* fetchRoleEffect({ payload }) {
    try {
        const { data: role } = yield call(RoleService.fetchRole, payload);
        yield (put(Actions.fetchRoleIdOk(role)));
    } catch ({ response }) {
        yield (
            put(
                Actions.fetchRoleIdFailed({
                    status: response.status,
                    message: response.data.message,
                    errors: []
                })
            )
        );
    }
}


export function* patchRoleEffect({ payload }) {
    try {
        yield call(RoleService.patchRole, payload);
        yield (put(Actions.patchRoleOk()));
    } catch ({ response }) {
        yield (
            put(
                Actions.patchRoleFailed({
                    status: response.status,
                    message: response.data.message,
                    errors: response.data.data.errors ? response.data.data.errors : null,
                })
            )
        );
    }
}

export default function* rootSaga() {
    yield takeLatest(Types.FETCH_ROLES, fetchRolesEffect);
    yield takeLatest(Types.ADD_ROLE, addRoleEffect);
    yield takeLatest(Types.FETCH_ROLE_ID, fetchRoleEffect);
    yield takeLatest(Types.PATCH_ROLE, patchRoleEffect);
}
